import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { blockTrendQuery } from '../../../data/providers/reports/blockReportProvider';
import { Entity, IComputedAggregate, IRange } from '../../../data/types';
import { MetricGraph } from '../../../ui/sections/test/metric_history/MetricGraph';
import { ListAvatar } from '../../shared/List/ListAvatar';
import { Card } from '../../shared/card/Card';
import { CardHeader } from '../../shared/card/CardHeader';
import { GraphContainer } from '../../shared/graphs/GraphContainer';
import { LinearLoading } from '../../shared/loading/LinearLoading';

interface IProps extends RouteComponentProps {
  entity: Entity;
  entityId: string;
  queryHash: string;
  range: IRange;
  metricName: string;
  metricKey: string;
}

const BlockTrendGraphComponent = (props: IProps): React.ReactElement => {
  const [dataLoading, setDataLoading] = React.useState<boolean>(true);
  const [sessions, setSessions] = React.useState<IComputedAggregate[]>([]);
  const [settingsLoading, setSettingsLoading] = React.useState<boolean>(true);

  React.useEffect((): (() => void) => {
    setDataLoading(true);

    const subscriber = blockTrendQuery({
      entityId: props.entityId,
      queryHash: props.queryHash,
      range: props.range,
    }).subscribe((mData: IComputedAggregate[]): void => {
      setDataLoading(false);
      setSessions(mData);
    });
    return (): void => {
      subscriber.unsubscribe();
    };
  }, [props.entityId]);

  return (
    <Card
      style={{
        minHeight: 'var(--graph-min-height)',
        padding: '0px',
      }}
    >
      <HistoryContainer>
        {(!!props.entityId && !!props.range) || settingsLoading ? (
          <React.Fragment>
            <CardHeader style={{ alignItems: 'center' }}>
              <div
                style={{
                  flex: 2,
                  display: 'flex',
                  flexDirection: 'row',
                  padding: '0 10px',
                }}
              >
                <ListAvatar entity={props.entity} />
              </div>
            </CardHeader>

            <GraphContainer
              style={{ padding: '10px ', height: 'calc(100% - 60px)' }}
            >
              {dataLoading ? (
                <LinearLoading />
              ) : (
                <MetricGraph
                  selectedMetric={{
                    label: props.metricName,
                    key: props.metricKey,
                  }}
                  sessions={sessions}
                />
              )}
            </GraphContainer>
          </React.Fragment>
        ) : (
          <LinearLoading />
        )}
      </HistoryContainer>
    </Card>
  );
};

export const BlockTrendGraph = withRouter(BlockTrendGraphComponent);

const HistoryContainer = styled.div`
  width: 100%;
  height: 100%;
`;
